import { useCallback } from 'react';
import { useAtom, SetStateAction } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { messageAtom, errorAtom, successAtom, ErrorMessage } from '../contexts/message';

interface Message {
  error: ErrorMessage | null | undefined;
  success: string | null | undefined;
  resetAll: () => void;
  setError: (update: SetStateAction<ErrorMessage | null | undefined>) => void;
  setSuccess: (update: SetStateAction<string | null | undefined>) => void;
  resetError: () => void;
  resetSuccess: () => void;
}

const useMessageHandler = (): Message => {
  const resetAll = useResetAtom(messageAtom);
  const [error, setError] = useAtom(errorAtom);
  const [success, setSuccess] = useAtom(successAtom);

  const resetError = useCallback(() => setError(null), []);

  const resetSuccess = useCallback(() => setSuccess(null), []);

  const message = {
    error,
    success,
    resetAll,
    setError,
    setSuccess,
    resetError,
    resetSuccess,
  };

  return message;
};

export default useMessageHandler;
